import { Component, Output, EventEmitter, Input, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { SearchService } from './../../../../../shared/services/search.service';
import { ExistingUser } from './../../../../../models/program/existing-user';

import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { NewUser } from '../../../../../models/program/new-user';
import { EditionService } from '../../../../../shared/services/edition.service';
import { filter } from 'rxjs/operators/filter';
import { of } from 'rxjs/observable/of';
import { Admin } from '../../../../../models/program/admin';
import { NewAndExistingUsers } from '../../../../../models/program/new-and-existing-users';

@Component({
  selector: 'app-existing-and-new',
  templateUrl: './existing-and-new.component.html',
  styleUrls: ['./existing-and-new.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ExistingAndNewComponent),
      multi: true
    }
  ]
})

export class ExistingAndNewComponent implements ControlValueAccessor {
  @Input() adminOrUser: 'admin' | 'user';
  @Input() highlightFirst = false;
  @Input() includeCompletion = false;
  @Input() enableNewUsers = true;

  public existingAndNewUsers: (ExistingUser | NewUser)[];
  private stringRegEx: RegExp = /^[a-zA-Z\s]*$/;
  public newUserData = null;
  private emitChange: ([]) => {};
  private emitTouched: () => {};

  constructor(
    private searchService: SearchService,
    private _fb: FormBuilder,
  ) { }

  writeValue(obj: any): void {
    this.existingAndNewUsers = obj;
  }
  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.emitTouched = fn;
  }

  public onAdding = (tag): Observable<any> => {
    let obs;
    let name = tag.name.split('Create New User: ')[1];
    if (tag.id === -1) {
      obs = of({
        name: '...create new user using form below',
        id: -1
      });
      this.newUserData = name;
    } else {
      obs = of(tag);
    }
    return obs;
  }

  public onFocus = (tag): void => {
    console.log();
  }

  public onItemRemoved = (tag): void => {
    if (tag.id === -1) {
      this.newUserData = null;
    }
  }

  public existingAndNewUsersChange(existingAndNewUsersUpdated: (ExistingUser | NewUser)[]): void {
    this.existingAndNewUsers = existingAndNewUsersUpdated;
    this.emitExistingAndNewUsers();
  }

  private emitExistingAndNewUsers() {
    this.emitTouched();
    this.emitChange(this.existingAndNewUsers);
  }

  public blankMatchingFn() {
    return true;
  }

  public searchForExisting = (query: string): Observable<NewAndExistingUsers> => {
    // Uses arrow notation to maintain scope, otherwise 'this' will be TagInputDropdown, not AddUsers
    return this.searchService.queryExistingUsers(query, this.includeCompletion)
      .map(returnedUsers => {
        if (this.adminOrUser === 'admin') {
          return returnedUsers.map(admin => {return {name: admin.name, id: admin.id}}) as ExistingUser[];
        } else {
          return returnedUsers as ExistingUser[];
        }
      })
      .map(returnedUsers => {
        if (this.enableNewUsers) {
          returnedUsers.push({
            name: 'Create New User: ' + query,
            id: -1
          });
        }
        return returnedUsers;
      })
  }

  public addNewUserToArray(newUserModel) {
    this.existingAndNewUsers.push({
      name: newUserModel.first_name + ' ' + newUserModel.last_name,
      id: 0,
      ...newUserModel
    })
    this.newUserData = null;
    // Remove placeholder for addition of new user
    this.existingAndNewUsers = this.existingAndNewUsers.filter(tag => tag.id !== -1);
    this.emitExistingAndNewUsers();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/add-users/existing-and-new/existing-and-new.component.ts